/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { initializeLocalization } from "./util/Localization";
import { constants } from "./constants/Constants";
import Router from "./router/Router";
import RequestManager from "./requests/RequestManager";
import OverlaySpinner from "./elements/indicators/OverlaySpinner";
import debug from "./util/Debug";
import { isCustomDomain, customDomainFavicon } from "./util/CustomDomain";
function App() {
  // initialize app
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    initializeLocalization(() => {
      debug.log("Localization initialized");
      setInitialized(true);
    }, (error) => {
      debug.error(error);
      alert("Error loading localization");
    });

    // Set favicon if custom domain
    if (isCustomDomain() && customDomainFavicon()) {
      const link = document.querySelector("link[rel='icon']") || document.createElement("link");
      if (link) {
        link.rel = "icon";
        link.href = customDomainFavicon(); // Change to your favicon URL
        document.head.appendChild(link);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  return initialized ? (
    <BrowserRouter basename={constants.routeBase}>
      <RequestManager />
      <Router />
    </BrowserRouter>
  ) : <OverlaySpinner />;
}

export default App;
